
$(document).ready(function() {

            $('.flickity-prev-next-button').click(function() {
              // Loop through each element with the 'yourDivSelector' class
              $('.product-gallery__carousel-item').each(function() {
                  // Check if the current element has the 'is-selected' class
                  if ($(this).hasClass('is-selected')) {
                      $(this).removeClass('product-gallery__carousel-item--hidden');
                  }
              });
          });
  
  var intervalIe = setInterval(function() {
      if($("#wishlisthero-product-page-button-container ").length) {
       // $('#wishlisthero-product-page-button-container').appendTo('.product-form__buy-buttons');
        //$( "#wishlisthero-product-page-button-container" ).insertAfter( ".product-form__buy-buttons" );
        $( "#wishlisthero-product-page-button-container" ).insertBefore( ".item_origin #item_origin_wrapper" );
		$('#wishlisthero-product-page-button-container').css('display','block');
        $("#wishlisthero-product-page-button-container").attr('title', 'Wishlist');
		
        clearInterval(intervalIe); // Stop the interval
        console.log('found');
        }
    }, 1000);
  
 
   jQuery(".formful__branding").attr('id', 'formfulbranding');
//  setTimeout(() => {
     if($(".tconditions input[type='checkbox']").is(":checked")) { 
           $(".header__action-item--cart #mini-cart button[name=checkout], .mini-cart__button-container .samitaWS-clone-checkout-button").prop('disabled', false);
           $('.mini-cart__button-container .button-group a.button').attr("disabled", false).css('pointer-events','all'); 
           
      }
//  }, 2000);

  $(document).on( "change", ".tconditions input[type='checkbox']", function(event) { 
     if($(this).is(":checked")) {
         $(".header__action-item--cart #mini-cart button[name=checkout], .mini-cart__button-container .samitaWS-clone-checkout-button").prop('disabled', false);
         $('.mini-cart__button-container .button-group a.button').attr("disabled", false).css('pointer-events','all');
    } else {
        $(".header__action-item--cart #mini-cart button[name=checkout], .mini-cart__button-container .samitaWS-clone-checkout-button").prop('disabled', true);
        $('.mini-cart__button-container .button-group a.button').attr("disabled", true).css('pointer-events','none');
         event.preventDefault();
    }
  });


  
   var footerheight =  jQuery(".shopify-section:has(footer.footer)").height();
   var headerheight = jQuery(".headr-menu").height();
    jQuery("#main").css('--min-height','calc(100vh - '+(footerheight + headerheight )+')');
    //console.log(footerheight);

     //default positions
     jQuery(".header__inner>.header__mobile-nav").css("--flex","flex");
     jQuery(".filter_cust").css("display","flex");
     jQuery(".part-finder-wrapper").css("display","block");

    //Aos script for sections float
    AOS.init({
      offset: 0, // offset (in px) from the original trigger point
      delay: 200, // values from 0 to 3000, with step 50ms
      duration: 3000, // values from 0 to 3000, with step 50ms
      easing: 'fade-down linear', // default easing for AOS animations
      mirror: true, // whether elements should animate out while scrolling past them
    });

    //footer link click open pathfinder
    jQuery('.footer__link-item.link').each(function(){
        if (jQuery(this).text() === 'Teilefinder' || jQuery(this).text() === 'teilefinder' || jQuery(this).text() === 'Parts finder' || jQuery(this).text() === 'Buscador de piezas' || jQuery(this).text() === 'Recherche de pièces' || jQuery(this).text() === 'Trova parti'){
            jQuery(this).click(function(e){
                jQuery('.part-finder-wrapper').trigger('click');
                e.preventDefault();
                return false;
            });
        }
    });
    jQuery('.desk_menu_middle .nav-bar__link.link , .mobile-menu__nav .mobile-menu__nav-link').each(function(){
          if (jQuery(this).text() === 'Sale%' || jQuery(this).text() === 'sale%' || jQuery(this).text() === 'SALE%' ) {
            jQuery(this).addClass('blinking-text');
          }

          if (jQuery(this).text() === 'Teilefinder' || jQuery(this).text() === 'teilefinder' || jQuery(this).text() === 'Parts finder' || jQuery(this).text() === 'Buscador de piezas' || jQuery(this).text() === 'Recherche de pièces' || jQuery(this).text() === 'Trova parti'){
              jQuery(this).click(function(e){
                  jQuery('.part-finder-wrapper').trigger('click');
                  e.preventDefault();
                  return false;
              });
          }
      });

  
    //slick slider for review mobile section
    $('.reviewrating.mobs .reviewratingcont').slick({
      dots: false,
      infinite: false,
      arrows: false,
      speed: 1500,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      fade: false,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
            }
        }
      ]
    });

  $('.grid_with_slider .grid_slider_slide').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      fade: true,
      cssEase: 'linear',
      prevArrow:"<button type='button' class='slick-prev pull-left'>&#8249;</button>",
      nextArrow:"<button type='button' class='slick-next pull-right'>&#8250;</button>"
    });
  
}); 



//jQuery Work on window resize also
jQuery(window).on('load resize', function () {

    let myMediaQueryw = window.matchMedia('(max-width: 640px)');
	    if(myMediaQueryw.matches) {
          var text = [".home_banner .slideshow__slide",".home_banner .slideshow__slide-inner",".home_banner .slideshow__image",".home_banner .flickity-viewport"];
          
          text.forEach(function(data){
                var maxHeight = 0;
                var slide_height = jQuery('.home_banner .slideshow__content-wrapper').outerHeight();
                jQuery(data).height(slide_height);
        });
    } else {
        jQuery(".home_banner .slideshow__slide, .home_banner .slideshow__slide-inner, .home_banner .slideshow__image").css('height','auto');
    }

    if (window.innerWidth > 999) { 
        $(window).scroll(function() {
              var scroll = $(window).scrollTop();
              //var scroll = window.pageYOffset;
              var desk_middle_anim = jQuery('.desk_menu_middle').height(); 
              //console.log(scroll);
              if(scroll > 1 ) {
                  $(".header").addClass("anim_scroll");
                  //$(".desk_menu_middle").addClass("nav-hide");
                  //$(".header__mobile-nav").addClass("hamburger-show");
                  //$(".headr-menu .header__logo").addClass("logo-centr");
                  //$(".desk_menu_bottom").addClass("mt-0");
                  //$(".desk_menu_middle").css("--middle-hight", desk_middle_anim+'px');
                  
                  
              } else {
                  $(".header").removeClass("anim_scroll");
                  //$(".desk_menu_middle").removeClass("nav-hide");
                  //$(".header__mobile-nav").removeClass("hamburger-show");
                  //$(".headr-menu .header__logo").removeClass("logo-centr");
                  //$(".desk_menu_bottom").removeClass("mt-0");
                  //$(".desk_menu_middle").css("--middle-hight", '0px');
                 
              }
        });
     }


    //header navbar animation on scroll  
     if (window.innerWidth > 767) {
      var conss = jQuery('.container').width()/2;
      
      var logohalf = jQuery('.header .header__logo-image').width()/2;
      var marleft = conss - logohalf;
      //jQuery(".header__logo").css("--marginlefts", marleft+ 'px');
     

        //sticky product search page sidebar 
      //   setTimeout(() => {
      //     var mainContentHeight = $("#gf-grid").height();
      //     var sidebarHeight = $("#gf-tree").height();
      //     var sticky_width = $("#gf-tree").outerWidth()+'px';
        
      //     $(document).on("scroll", function() {
      //         var offsets = $(".layout__section").length > 0 ? $(".layout__section").offset().top : 0 ;
      //         var con = jQuery('.container').width();
      //         var wwidth = jQuery('body').width();
      //         var lft = (wwidth - con)/2;
              
      //          //position sidebar on top'
      //          if ($(window).scrollTop() <= offsets + 100 ) { 
      //            $("#gf-tree").removeClass('fix-wid');
      //            $("#gf-tree").css({position: 'relative',
      //                               top: 0,
      //                               left:'unset'
      //                               });
      //         }
      //         //position sidebar on bottom'
      //         else if ($(window).scrollTop() + sidebarHeight > mainContentHeight + offsets + 100) {
      //            $("#gf-tree").removeClass('fix-wid');
      //            $("#gf-tree").css({position: 'absolute',
      //                                top: mainContentHeight - sidebarHeight + offsets,
      //                                left:'unset'
      //                               });
      //         }
      //         //fixed sidebar until reach top or bottom'
      //         else {
      //             $("#gf-tree").addClass('fix-wid');
      //             $("#gf-tree").css({position: 'fixed',
      //                                '--width':sticky_width,
      //                               left:lft+'px',
      //                               top: offsets
      //                               });
      //         }
      //     });
      // }, 1500);
  }else{}
}).resize();
